
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';
import '../styles/pages/_modules.scss';

const yogaImage = require('../assets/yoga.png');

const sessions = [
  {
    id: 1,
    title: 'Session 1: Morning Yoga Flow',
    path: '/panel/dashboard/yoga-flow/session-1',
  },
  {
    id: 2,
    title: 'Session 2: Flexibility Flow',
    path: '/panel/dashboard/yoga-flow/session-2',
  },
  {
    id: 3,
    title: 'Session 3: Relaxation Flow',
    path: '/panel/dashboard/yoga-flow/session-3',
  },
  {
    id: 4,
    title: 'Session 4: Strength Flow',
    path: '/panel/dashboard/yoga-flow/session-4',
  },
  {
    id: 5,
    title: 'Session 5: Energy Flow',
    path: '/panel/dashboard/yoga-flow/session-5',
  },
];

const YogaFlowPage: React.FC = () => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  return (
    <div className={`resources-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="module-resources_container">
        {/* Header Section */}
        <div className="module-resources_header">
          <div className="module-resources_header-content">
            <div className="module-resources_header-text">
              <h2>Yoga Flow</h2>
            </div>
          </div>
        </div>

        {/* Modules Grid */}
        <div className="module-resources_modules">
          <div className="module-resources_modules-grid">
            {sessions.map((s) => (
              <div
                key={s.id}
                className="module-resources_module-card"
                onClick={() => navigate(s.path)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') navigate(s.path);
                }}
              >
                <div className="module-resources_module-image">
                  <img src={yogaImage.default || yogaImage} alt={s.title} />
                </div>
                <div className="module-resources_module-content">
                  <h3 className="module-resources_module-title">{s.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default YogaFlowPage;

